import { render } from "./TheWinner.vue?vue&type=template&id=85af0e9e&scoped=true"
import script from "./TheWinner.vue?vue&type=script&lang=js"
export * from "./TheWinner.vue?vue&type=script&lang=js"

import "./TheWinner.vue?vue&type=style&index=0&id=85af0e9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85af0e9e"]])

export default __exports__